import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      questionsBanner: {
        livejasmin: {
          ...defineMessages({
            title: {
              id: 'pages.landing.questionsBanner.livejasmin.title',
              defaultMessage: 'Have <b>questions?</b>',
            },
            description: {
              id: 'pages.landing.questionsBanner.livejasmin.description',
              defaultMessage: 'Reach out to our 24/7 live chat support, they are here to help you at any time!',
            },
            moreInfo: {
              id: 'pages.landing.questionsBanner.livejasmin.moreInfo',
              defaultMessage: 'More information',
            },
          }),
          first: defineMessages({
            question: {
              id: 'pages.landing.questionsBanner.livejasmin.first.question',
              defaultMessage: 'What do I need to sign up as a model?',
            },
            answer: {
              id: 'pages.landing.questionsBanner.livejasmin.first.answer',
              defaultMessage:
                'To create your own account, you must be over {minAge} and possess a valid, government-issued ID. After clicking the “Join now” button, you can begin creating your account. Sign up is completely free, you will never be charged any fees for it.',
            },
          }),
          second: defineMessages({
            question: {
              id: 'pages.landing.questionsBanner.livejasmin.second.question',
              defaultMessage: 'Can I work whenever I want?',
            },
            answer: {
              id: 'pages.landing.questionsBanner.livejasmin.second.answer',
              defaultMessage:
                'Yes! You have complete control over when and how much you work. If you want to make webcam modeling your primary source of income, we offer tools to track and optimize your progress.',
            },
          }),
          third: defineMessages({
            question: {
              id: 'pages.landing.questionsBanner.livejasmin.third.question',
              defaultMessage: 'How much money can I make working as a LiveJasmin model?',
            },
            answer: {
              id: 'pages.landing.questionsBanner.livejasmin.third.answer',
              defaultMessage:
                'There is no limit to how much you can earn. Standard payouts are issued bi-weekly, with a minimum payout threshold of {threshold}. Your pending earnings are securely stored until you reach this limit. Based on your preferences you can also change the frequency of your payouts or trigger a payout manually.',
            },
          }),
          fourth: defineMessages({
            question: {
              id: 'pages.landing.questionsBanner.livejasmin.fourth.question',
              defaultMessage: 'What kind of equipment and computer do I need to start streaming?',
            },
            answer: {
              id: 'pages.landing.questionsBanner.livejasmin.fourth.answer',
              defaultMessage:
                "To get started, you'll need a good-quality webcam, a reliable computer, and a stable internet connection. Please check our Technical Requirements for detailed specifications.",
            },
          }),
          fifth: defineMessages({
            question: {
              id: 'pages.landing.questionsBanner.livejasmin.fifth.question',
              defaultMessage: 'How does LiveJasmin guarantee my safety, privacy, and anonymity?',
            },
            answer: {
              id: 'pages.landing.questionsBanner.livejasmin.fifth.answer',
              defaultMessage:
                '<li>All personal data provided during sign-up is handled securely and in compliance with data protection laws.</li>' +
                '<li>You can make your account invisible to users from your home country or state and block users from up to three additional countries or states.</li>' +
                '<li>Create a list of banned words to block specific terms in your chat. Use this feature carefully, as it might affect your traffic and earnings.</li>' +
                '<li>Utilize the Face Visibility feature to hide your face while streaming if you prefer to maintain anonymity.</li>',
            },
          }),
        },
      },
    },
  },
};
